import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20peach%20and%20coral%20tones%2C%20flowing%20organic%20shapes%2C%20minimalist%20artistic%20design%2C%20subtle%20texture%2C%20modern%20elegant%20atmosphere%2C%20digital%20art%20style%2C%20dreamy%20ambient%20lighting%2C%20clean%20composition%2C%20no%20text&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="蜜桃传媒背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 md:mb-6">
            {heroData.title}
          </h1>
          <p className="text-sm md:text-lg text-background-50/85 leading-relaxed mb-8 md:mb-10 max-w-2xl mx-auto">
            {heroData.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaPrimary}
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/15 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaSecondary}
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 md:mt-16">
            {heroData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-50/70 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}